// extracted by mini-css-extract-plugin
module.exports = {"root":"_2rFNAGV6-x-QVNS13ZFqn9"};